import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';
import { environment } from 'environments/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();

  Sentry.init({
    dsn: 'https://49a62d9b23fa4102932273c21020490d@sentry.ispsystem.net/17',
    release: environment.sentry,
    tracesSampleRate: 1.0,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
